import { render, staticRenderFns } from "./NpvsBlock.vue?vue&type=template&id=3ce99ed6&lang=pug&"
import script from "./NpvsBlock.vue?vue&type=script&lang=js&"
export * from "./NpvsBlock.vue?vue&type=script&lang=js&"
import style0 from "./NpvsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports